// vim: ft=javascriptreact
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const EventView = ({ event, isAdmin }) => {
  const {
    bookingId,
    confirmed,
    myBooking,
    officialUse,
    title,
  } = event.extendedProps
  const type = confirmed ? 'Booked' : 'Requested'
  const tooltip = myBooking ? `${type} by you` : `${type} by someone else`
  const navigate = useNavigate()
  const onClick = isAdmin ? () => { navigate(`/admin/bookings/confirm/${bookingId}`) } : null

  if (officialUse) {
    return (
      <div>
        <i className="fa fa-crown" />
        {` ${title} `}
        <i className="fa fa-crown" />
      </div>
    )
  }

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>{tooltip}</Tooltip>
      }
    >
      <div onClick={onClick}>
        {!confirmed && <i className="fa fa-circle-question" />}
        {confirmed && <i className="fa fa-circle-check" />}
        {' '}
        {event.title}
        {myBooking && (
          <div style={{ float: 'right' }}>
            <i className="fa fa-crown" />
          </div>
        )}
      </div>
    </OverlayTrigger>
  )
}

export default EventView
